angular.module('common').filter('translate', function() {
  return function(key) {
    return I18n.t(key);
  };
});
